import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { RegUser } from '../basic-reg/RegUser';
import { Globals } from 'src/app/globals';


@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    HeaderComponent,
    FooterComponent
  ]
})
export class TermsAndConditionsComponent implements OnInit {

  user: RegUser = new RegUser();
  LoggedIn: boolean = false;

  constructor(public authService: AuthServiceService, public global: Globals) { }

  ngOnInit(): void {
  }

  ionViewWillEnter() {    
    this.user = this.authService.getLoggedInUser();
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

}
